export const RANGE_SLIDER_DIMENSION = 28;
